import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import FlowButton from './FlowButton';

function NextQuestionButton ({onClick}) {
    
    return <FlowButton className='baseElementsconfirmButton' onClick={onClick} name={"Prossima Domanda"}></FlowButton>
}

export default NextQuestionButton;